export const ChartColors = ['#a2798f', '#2a623d', '#77ab59', '#c9df8a', '#83adb5', '#ffcf40', '#e0a899', '#65c3ba', '#e2eeff', '#dbc1ac'];
